import { render, staticRenderFns } from "./IpLocation.vue?vue&type=template&id=08fc9f1e&scoped=true&"
import script from "./IpLocation.vue?vue&type=script&lang=js&"
export * from "./IpLocation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08fc9f1e",
  null
  
)

export default component.exports